'use strict';
import {module} from '../app';

module.controller('OptionsCtrl', [
    '$scope', '$location', '$http', 'authService', '$ionicLoading', 'modalService', 'localStorage', 'techpadOptions',
    function ($scope, $location, $http, authService, $ionicLoading, modalService, localStorage, techpadOptions) {


      techpadOptions.getOptions();
      $scope.techpadOptions = techpadOptions.options;

      $scope.toggleDarkMode = function () {
        $scope.techpadOptions.DarkMode = !$scope.techpadOptions.DarkMode;
        techpadOptions.saveOptions();        
      };

      $scope.toggleTotalTimeDisplay = function () {
        $scope.techpadOptions.DisplayTotalTimePatientHasBeen = !$scope.techpadOptions.DisplayTotalTimePatientHasBeen;
        techpadOptions.saveOptions();
      };

      $scope.saveOptions = function () {
        techpadOptions.saveOptions();
        if(!$scope.techpadOptions.DarkMode && $('body').hasClass('dark-mode')){
          $('body').removeClass('dark-mode');
        }else if($scope.techpadOptions.DarkMode &&  !$('body').hasClass('dark-mode')){
          $('body').addClass('dark-mode');
        }
      };

      $scope.cleanUpData = function () {
        modalService.showConfirmation(function () {
          localStorage.cleanUp();
        }, 'Are you sure to clean the application\'s data?')
      };
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/options.js